import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TableModelObject } from "./TableModelObject";

export class FixedIndexRow {
  constructor(public modelObject: TableModelObject) {
    // take ownership of model object properties
    Object.assign(this, modelObject);
  }
}
